function registerResource(registry, allowDuplications, resource) {
    if (registry.has(resource)) {
        return;
    }
    const registered = Array.from(registry).find(r => r.name === resource.name);
    if (registered && !allowDuplications) {
        console.groupCollapsed(`Resource ${resource.name} is already registered and must be unique.`);
        console.info(`Current:`, registered);
        console.info(`New:`, resource);
        console.groupEnd();
        return;
    }
    registry.add(Object.freeze(resource));
}
function getResources(registry) {
    return Array.from(registry);
}
function getResource(registry, name) {
    return Array.from(registry).find(r => r.name === name);
}
function removeResource(registry, resource) {
    if (typeof resource === 'string') {
        Array.from(registry).forEach(r => {
            if (r.name === resource) {
                registry.delete(r);
            }
        });
    }
    else {
        registry.delete(resource);
    }
}
/**
 * Creates a new registry of resources
 * @public
 * @param allowDuplications - If true, allows duplicated resources by name
 * @returns Resource registry
 */
export function createResourceRegistry(allowDuplications = false) {
    const resourceRegistry = new Set();
    return {
        add: registerResource.bind(null, resourceRegistry, allowDuplications),
        list: getResources.bind(null, resourceRegistry),
        get: getResource.bind(null, resourceRegistry),
        remove: removeResource.bind(null, resourceRegistry),
    };
}
